/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Dialect_Hint_Ebrana_Getjob_XmlInputs */

const cs_import_dialect_hint_ebrana_getjob_xml = /** @type {(inputs: Import_Dialect_Hint_Ebrana_Getjob_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jednorázová migrace z exportu eBRÁNA (GetJob.php), nejde o průběžnou synchronizaci. Vložte odkaz na feed nebo nahrajte XML soubor. Existující nemovitosti spárujeme podle ID z exportu nebo čísla zakázky. Makléři se načtou z vnořených GetUser id. Ostatní založíme jako nové.`)
};

const en_import_dialect_hint_ebrana_getjob_xml = /** @type {(inputs: Import_Dialect_Hint_Ebrana_Getjob_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time migration from an eBRÁNA export (GetJob.php), not an ongoing sync. Paste the feed link or upload the XML file. Existing listings are matched by export ID or listing code. Brokers are loaded from nested GetUser ids. Everything else is created as new.`)
};

/**
* | output |
* | --- |
* | "One-time migration from an eBRÁNA export (GetJob.php), not an ongoing sync. Paste the feed link or upload the XML file. Existing listings are matched by expo..." |
*
* @param {Import_Dialect_Hint_Ebrana_Getjob_XmlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_dialect_hint_ebrana_getjob_xml = /** @type {((inputs?: Import_Dialect_Hint_Ebrana_Getjob_XmlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Dialect_Hint_Ebrana_Getjob_XmlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_dialect_hint_ebrana_getjob_xml(inputs)
	return cs_import_dialect_hint_ebrana_getjob_xml(inputs)
});